import styled from "styled-components";
import McLogo from "./mc-logo_30x24.svg";

export default styled(function MasterCardLogo({ className }) {
  return (
    <img
      className={className}
      src={McLogo}
      width="30"
      height="24"
      alt="MasterCard"
    />
  );
})``;
